// extracted by mini-css-extract-plugin
export default {"services":"Services_services__kq59q","services__title":"Services_services__title__uGibP","services__description":"Services_services__description__A7WIk"};